import { Deserializable } from '../deserializable';

export class Address implements Deserializable {
  public AddressID: number;
  public AddressLine1: string;
  public AddressLine2: string;
  public AddressLine3: string;
  public County: string;
  public FromPaf?: boolean;
  public Name: string;
  public PhoneNumber: string;
  public Postcode: string;
  public Email: string;
  public CountryTypeCode: string;
  public CountryCode: string;
  public FaxNumber: string;

  deserialize(input: any): this {
    Object.assign(this, input);
    delete (this as any).$id;

    return this;
  }

  public copyAddressFields(source: Address): void {
    this.CountryTypeCode = source.CountryTypeCode;
    this.CountryCode = source.CountryCode;
    this.FromPaf = source.FromPaf;
    this.Postcode = source.Postcode;
    this.AddressLine1 = source.AddressLine1;
    this.AddressLine2 = source.AddressLine2;
    this.AddressLine3 = source.AddressLine3;
    this.County = source.County;
  }
}
